import React, { useRef } from "react";
import "./Category_slider.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

function Category_slider({ products, selectedProduct, setSelectedProduct }) {
  const swiperRef = useRef(null);

  return (
    <section className="Category_slider_holder">
      <div className="Category_slider d-flex align-items-center">
        {/* Fixed All Button */}
        <div
          className={`category_card fixed_all ${
            selectedProduct === null ? "active" : ""
          }`}
          onClick={() => setSelectedProduct(null)}
        >
          <div className="text_holder">
            <h6>All</h6>
            All
          </div>
        </div>

        {/* Slider */}
        <div className="slider_wrapper">
          {/* Navigation */}
          <div className="slider_nav prev">
            <FontAwesomeIcon icon={faAngleLeft} />
          </div>

          <div className="slider_nav next">
            <FontAwesomeIcon icon={faAngleRight} />
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            loop={products.length > 1}
            speed={800}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              prevEl: ".prev",
              nextEl: ".next",
            }}
            rewind={false}
            slidesPerView={"auto"}
            spaceBetween={15}
            centeredSlides={false}
            allowTouchMove={true}
            breakpoints={{
              0: {
                spaceBetween: 10,
              },
              576: {
                spaceBetween: 12,
              },
              768: {
                spaceBetween: 15,
              },
              
            }}
            className="category_swiper"
          >
            {products.map((item, index) => (
              <SwiperSlide key={item.id}>
                <div
                  className={`category_card ${
                    selectedProduct?.id === item.id ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedProduct(item);

                    if (swiperRef.current) {
                      swiperRef.current.slideTo(index);
                    }
                  }}
                >
                  <div className="text_holder">
                    <h6>{item.name}</h6>
                    {item.name}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Category_slider;
